import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';
import { MessagesModule } from 'primeng/messages';
import { ToastModule } from 'primeng/toast';

import { FormFieldHelpComponent } from '../../form/form-field-help/form-field-help.component';
import { DataTableModule } from '../../generic/data-table/data-table.module';
import { SettingsModule } from '../../generic/settings/settings.module';
import { ProgressSpinnerModule } from '../progress-spinner/progress-spinner.module';

import { EventRequestConfigEditorComponent } from './editor/event-request-config-editor/event-request-config-editor.component';
import { EventRequestConfigTableComponent } from './editor-table/event-request-config-table/event-request-config-table.component';

@NgModule({
  declarations: [EventRequestConfigTableComponent],
  imports: [
    ButtonModule,
    CheckboxModule,
    CommonModule,
    DataTableModule,
    DynamicDialogModule,
    EventRequestConfigEditorComponent,
    FormFieldHelpComponent,
    FormsModule,
    InputTextModule,
    MatIconModule,
    MessagesModule,
    ProgressSpinnerModule,
    ReactiveFormsModule,
    SettingsModule,
    ToastModule,
    TranslocoModule,
  ],
  exports: [EventRequestConfigEditorComponent, EventRequestConfigTableComponent],
})
export class EventRequestConfigModule {}
